<template>
   <div class="d-flex align-center justify-center w-full h-full background">
     <simulator class="sim" :showWatermark="false">
       <div class="d-flex flex-column w-full pa-3 pt-5 sim-body-contain">
        <div class="message-inbound message pa-2 pl-4 pr-4">
          <div class="text-404">404</div>
        </div>
        <div class="justify-end w-100 d-flex">
          <div class="message-outbound message pa-2 pl-4 pr-4 mt-3">
            <div>Whoops, this page cannot be found.</div>
          </div>
        </div>
        <div class="message-inbound message pa-2 pl-4 pr-4 mt-3" @click.prevent="goBack" style="cursor:pointer">
          <div class="d-flex">
            <v-icon size="24">mdi-arrow-left</v-icon>
            <div class="go-back-text">Click here to Go Back</div>
          </div>
        </div>
       </div>
     </simulator>
   </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Simulator from '@/components/Simulator.vue';

export default Vue.extend({
  components: { Simulator },
  name: 'NotFound',
  methods: {
    goBack():void {
      window.history.back();
    },
  },
});
</script>

<style lang="scss" scoped>
.sim-body-contain {
  height: 32em;
}
.background {
  background-color: var(--v-graybkg-base);
}
.sim {
  width: 22em;
}
.message {
  max-width: 80%;
}
.text-404 {
  font-size: 5em;
  text-align: center;
}
.go-back-text {
  margin-top: 0.15em;
}
</style>
